import { useTooltipContentProps as Y } from "./index680.js";
import { defineComponent as q, ref as E, inject as G, computed as l, onBeforeUnmount as Q, unref as o, watch as y, openBlock as S, createBlock as w, withCtx as d, Transition as X, withDirectives as Z, createVNode as _, mergeProps as ee, renderSlot as te, vShow as oe, createCommentVNode as ne } from "vue";
import { onClickOutside as re } from "./index562.js";
import { ElTeleport as ae } from "./index741.js";
import { TOOLTIP_INJECTION_KEY as le } from "./index691.js";
import { isTriggerType as I } from "./index794.js";
import { usePopperContainerId as ie } from "./index708.js";
import { castArray as se } from "./index765.js";
import ue from "./index568.js";
import { useNamespace as ce } from "./index559.js";
import { composeEventHandlers as N } from "./index589.js";
import { focusElement as pe } from "./index566.js";
import { computedEager as fe } from "./index599.js";
var Ne = /* @__PURE__ */ q({
  name: "ElTooltipContent",
  inheritAttrs: !1,
  __name: "content",
  props: Y,
  setup(t, { expose: P }) {
    const r = t, { selector: R } = ie(), k = ce("tooltip"), a = E(), B = fe(() => {
      var e;
      return (e = a.value) == null ? void 0 : e.popperContentRef;
    });
    let i;
    const {
      controlled: v,
      id: O,
      open: p,
      trigger: f,
      onClose: u,
      onOpen: A,
      onShow: H,
      onHide: L,
      onBeforeShow: m,
      onBeforeHide: g
    } = G(le, void 0), x = l(() => r.transition || `${k.namespace.value}-fade-in-linear`), C = l(() => process.env.NODE_ENV === "test" && !process.env.RUN_TEST_WITH_PERSISTENT ? !0 : r.persistent);
    Q(() => {
      i?.();
    });
    const M = l(() => o(C) ? !0 : o(p)), b = l(() => r.disabled ? !1 : o(p)), $ = l(() => r.appendTo || R.value), z = l(() => {
      var e;
      return (e = r.style) != null ? e : {};
    }), c = E(!0), V = () => {
      L(), h() && pe(document.body, { preventScroll: !0 }), c.value = !0;
    }, T = () => {
      if (o(v)) return !0;
    }, D = N(T, () => {
      r.enterable && I(o(f), "hover") && A();
    }), U = N(T, () => {
      I(o(f), "hover") && u();
    }), W = () => {
      var e, n;
      (n = (e = a.value) == null ? void 0 : e.updatePopper) == null || n.call(e), m?.();
    }, j = () => {
      g?.();
    }, F = () => {
      H();
    }, J = () => {
      r.virtualTriggering || u();
    }, h = (e) => {
      var n;
      const s = (n = a.value) == null ? void 0 : n.popperContentRef, K = e?.relatedTarget || document.activeElement;
      return s?.contains(K);
    };
    return y(
      () => o(p),
      (e) => {
        e ? (c.value = !1, i = re(
          B,
          () => {
            if (o(v)) return;
            se(o(f)).every((s) => s !== "hover" && s !== "focus") && u();
          },
          { detectIframe: !0 }
        )) : i?.();
      },
      {
        flush: "post"
      }
    ), y(
      () => r.content,
      () => {
        var e, n;
        (n = (e = a.value) == null ? void 0 : e.updatePopper) == null || n.call(e);
      }
    ), P({
      /**
       * @description el-popper-content component instance
       */
      contentRef: a,
      /**
       * @description validate current focus event is trigger inside el-popper-content
       */
      isFocusInsideContent: h
    }), (e, n) => (S(), w(o(ae), {
      disabled: !t.teleported,
      to: $.value
    }, {
      default: d(() => [
        M.value || !c.value ? (S(), w(X, {
          key: 0,
          name: x.value,
          appear: !C.value,
          onAfterLeave: V,
          onBeforeEnter: W,
          onAfterEnter: F,
          onBeforeLeave: j,
          persisted: ""
        }, {
          default: d(() => [
            Z(_(o(ue), ee({
              id: o(O),
              ref_key: "contentRef",
              ref: a
            }, e.$attrs, {
              "aria-label": t.ariaLabel,
              "aria-hidden": c.value,
              "boundaries-padding": t.boundariesPadding,
              "fallback-placements": t.fallbackPlacements,
              "gpu-acceleration": t.gpuAcceleration,
              offset: t.offset,
              placement: t.placement,
              "popper-options": t.popperOptions,
              "arrow-offset": t.arrowOffset,
              strategy: t.strategy,
              effect: t.effect,
              enterable: t.enterable,
              pure: t.pure,
              "popper-class": t.popperClass,
              "popper-style": [t.popperStyle, z.value],
              "reference-el": t.referenceEl,
              "trigger-target-el": t.triggerTargetEl,
              visible: b.value,
              "z-index": t.zIndex,
              loop: t.loop,
              onMouseenter: o(D),
              onMouseleave: o(U),
              onBlur: J,
              onClose: o(u)
            }), {
              default: d(() => [
                te(e.$slots, "default")
              ]),
              _: 3
              /* FORWARDED */
            }, 16, ["id", "aria-label", "aria-hidden", "boundaries-padding", "fallback-placements", "gpu-acceleration", "offset", "placement", "popper-options", "arrow-offset", "strategy", "effect", "enterable", "pure", "popper-class", "popper-style", "reference-el", "trigger-target-el", "visible", "z-index", "loop", "onMouseenter", "onMouseleave", "onClose"]), [
              [oe, b.value]
            ])
          ]),
          _: 3
          /* FORWARDED */
        }, 8, ["name", "appear"])) : ne("v-if", !0)
      ]),
      _: 3
      /* FORWARDED */
    }, 8, ["disabled", "to"]));
  }
});
export {
  Ne as default
};
